var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMembershipStandard28X14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 14,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.21 0h-8.384a2.823 2.823 0 0 0-2.818 2.816v8.354a2.823 2.823 0 0 0 2.818 2.816h8.357a2.823 2.823 0 0 0 2.818-2.816V2.803a2.797 2.797 0 0 0-2.804-2.79",
  fill: "#21AB73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.203.014H2.818A2.823 2.823 0 0 0 0 2.83v8.354A2.823 2.823 0 0 0 2.818 14h8.371a2.823 2.823 0 0 0 2.818-2.816V2.816A2.8 2.8 0 0 0 11.203.014Z",
  fill: "#192D82"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.056 11.088a.912.912 0 1 1-1.823 0 .912.912 0 0 1 1.823 0Z",
  fill: "#2E80FF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.95 7.89c-.299 0-.598.191-.748.395-.477.545-1.103.98-1.933.98a2.277 2.277 0 0 1-2.287-2.259c0-1.21.98-2.258 2.287-2.258.83 0 1.456.422 1.933.98.15.19.45.394.749.394.544 0 .925-.408.925-.857a.954.954 0 0 0-.15-.53C9.978 3.645 8.78 2.937 7.283 2.937c-2.328 0-4.138 1.783-4.138 4.082 0 2.3 1.81 4.082 4.138 4.082 1.497 0 2.695-.694 3.443-1.783a.967.967 0 0 0 .15-.544c0-.449-.381-.857-.925-.857",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.056 11.088a.912.912 0 1 1-1.823 0 .912.912 0 0 1 1.823 0Z",
  fill: "#2E80FF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.004 2.911a.912.912 0 0 0-.912.912v6.313a.912.912 0 0 0 1.824 0V3.823a.912.912 0 0 0-.912-.912Z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M25.087 6.98a.912.912 0 0 0-.912-.912h-6.33a.912.912 0 1 0 0 1.823h6.33a.912.912 0 0 0 .912-.911Z",
  fill: "#fff"
})));
export default SvgIcMembershipStandard28X14;